export let RESTAURANT_SALE_TAX = 'saleTax';
export const RESTAURANT_ID = 'restaurant_id';
export const RESTAURANT_NAME = 'restaurant_name';
export const RESTAURANT_LOGO = 'restaurant_logo';
export const RESTAURANT_LOCATION_ID = 'restaurant_location_id';
export const RESTAURANT_LOCATION_DETAILS = 'restaurant_details';
